// src/services/projectService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Eliminar un bloque
export const deleteBlock = async (id,force=false) => {
  try {
    if (force) {
      const response = await axiosInstance.delete(`${API_URL}/block/${id}?force=true`);
      return response;
    }
    const response = await axiosInstance.delete(`${API_URL}/block/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Obtener un bloque por su ID
export const getBlockById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/block/${id}`);
    if (!response.mediaItems) {
      response.mediaItems = [];
    }
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Actualizar un bloque existente
export const saveBlock = async (block) => {
  try {
    const newBlock = {
      createdAt: block.createdAt,
      name: block.name,
      code: block.code,
      description: block.description,
      slug: block.slug,
      stageId: block.stageId,
      priceList: block.priceList,
      orbitViews: block.orbitViews,
      smlvPrice: block.smlvPrice || '0',
      targetFrame: block.targetFrame,
      glbCode: (!block.glbCode || block.glbCode===''? block.slug:block.glbCode),
      mediaItems: block.mediaItems || []
    }
    if (block.id) {
      newBlock.id = block.id;
    }
    const response = await axiosInstance.put(`${API_URL}/block`, newBlock);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
